import React, { useState } from 'react'
 

import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import { postPayrolls } from '../../../../MyApi/hr/payrolls'

import PageHeader from '../../../../Components/UI/PageHeader'
import AddPayrolls from '../../../../Components/hr/payrolls/payrollsStore/AddPayrolls'




const PayrollsStore = () => {
const [date ,setDate]= useState("")    
const [deserved_amount, setDeservedAmount] = useState("")
const [undeserved_amount ,setUndeservedAmount] =useState("")
const [extra_amount , setExtraAmount] = useState("")
const [discountAmount ,setDiscountAmont] = useState("")
const [loan_amount , setLoanAmount] = useState("")
const [hr_contract_id , setHrContractId] =useState("")
const [sb_branch_id, setBranchId]=useState("")
const [sb_company_id ,setCompanyId]= useState("")
const [status ,setStatus] =useState("")
const [auto ,setAuto]=useState(1)

const [description, setDescription] = useState("")
const [sb_employe_id,setEmployId] =useState("")

 const mutation = useMutation("postpayrolls" , (postData)=>postPayrolls(postData) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setDate("")
        setDeservedAmount("")
        setUndeservedAmount("")
        setExtraAmount("")
        setDiscountAmont("")
        setLoanAmount("")
        setStatus("")
        setCompanyId("")
        setDescription("")
    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        date,  
        description,
        sb_employe_id,
        deserved_amount,
        extra_amount,
        discountAmount,
        loan_amount,
        sb_company_id,
        auto,
        status,
        sb_branch_id,
        hr_contract_id,


    })
 }
 const isDisabled= ()=>{
  return   !(sb_company_id && description  && deserved_amount && status && date  &&loan_amount &&sb_branch_id &&extra_amount)

 }
  return ( 

    <div>
        <PageHeader title="Add Payrolls" showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddPayrolls setEmployId={setEmployId} date={date}  undeserved_amount={undeserved_amount} setUndeservedAmount={setUndeservedAmount}  setDeservedAmount={setDeservedAmount}  setExtraAmount={setExtraAmount} setDiscountAmont={setDiscountAmont}  setLoanAmount={setLoanAmount} setHrContractId={setHrContractId} setStatus={setStatus}   setBranchId={setBranchId}    setAuto={setAuto}    setCompanyId={setCompanyId} setDate={setDate} setDescription={setDescription} description={description} auto={auto} />
    </div>
  )
}

export default PayrollsStore